// extracted by mini-css-extract-plugin
export default {"resource-locator":"resource-locator--k7xfnETJXV","resourceLocator":"resource-locator--k7xfnETJXV","fixed":"fixed--vjkfEJy7y-"};